import {
  FormFieldSchema,
  FormFieldType,
} from "@app/components/forms/types/schema";

export const CategorySchema: FormFieldSchema[] = [
  {
    // 다중 선택 UI로 변경 필요
    type: FormFieldType.Text,
    id: "category",
    label: "카테고리 번호",
    description:
      "특정 플랫폼(카페24, 플렉스지)에서 카테고리 번호에 해당하는 경우에만 보이도록 설정 가능합니다.",
  },
];
